import { SelectInput } from 'components/Select';



// interface OptionProps {
//   label: string;
//   value: string;
// }

// interface ConfigOptionsDropdownProps {
//   options: OptionProps[];
// }

const ConfigOptionsDropdown = ({ ...props }) => {

  return (
    <>
      <SelectInput
        {...props}
        className={"select-filter"}
        classNamePrefix={"an-simple-select"}
      />
    </>

  );
};

export default ConfigOptionsDropdown;
